/*
  Simply sets the `selected` <option> for the `address[country]` field.
  {{ country_option_tags }} is a kind of a mistery…
*/
export default function () {
  let $elements = document.querySelectorAll('select[name="address[country]"]')

  for (let i = 0; i < $elements.length; i++) {
    init($elements[i])
  }
}

function init ($element) {
  let value = $element.dataset.default

  if (value) {
    $element.value = value
  }
}
